import { createFileRoute } from '@tanstack/react-router';

import { ContainerLayout } from '@/components/ContainerLayout';
import { LegalHeading } from '@/components/legal/LegalHeading';
import { LegalText } from '@/components/legal/LegalText';

function PolicyRoute() {
  return (
    <ContainerLayout>
      <LegalHeading>Nutzungsbedingungen</LegalHeading>

      <LegalText>
        Willkommen zu unserem digitalen Verkehrszeichenkataster, einer Web-Anwendung, die vom Verkehrsministerium
        Baden-Württemberg betrieben wird. Diese Nutzungsbedingungen regeln die Nutzung unserer Web-Anwendung und der
        darin enthaltenen Daten. Bitte lesen Sie diese sorgfältig durch, bevor Sie unsere Dienste nutzen.
      </LegalText>
      <br />
      <LegalText>
        Diese Nutzungsbedingungen sowie die auf der Website zur Verfügung gestellten Informationen einschließlich der
        Dokumente zum Download werden von Zeit zu Zeit überarbeitet und Änderungen hieran vorgenommen oder Ergänzungen
        hinzugefügt; diese Änderungen und/oder Ergänzungen werden in neuen Ausgaben der Nutzungsbedingungen und der
        Dokumente eingefügt. Das VM kann jederzeit Verbesserungen und/oder Veränderungen an den angebotenen
        Informationen und Dokumenten vornehmen.
      </LegalText>

      <ol>
        <li>
          <b>Geltungsbereich und Akzeptanz der Nutzungsbedingungen</b>
          <ol>
            <li>
              Durch die Nutzung dieser Web-Anwendung stimmen Sie diesen Nutzungsbedingungen zu. Wenn Sie nicht mit
              diesen Bedingungen einverstanden sind, dürfen Sie die Web-Anwendung nicht nutzen.
            </li>
          </ol>
        </li>
        <li>
          <b>Datenquellen und Datenlizenzen</b>
          <ol>
            <li>
              Die Nutzung der Daten ist ausschließlich auf die folgenden Zwecke begrenzt: Effiziente Straßenüberwachung
              und Straßeninstandhaltung, Verbesserung der Verkehrssicherheit, die Ableitung operativer und strategischer
              Maßnahmen zur Straßeninstandhaltung für die erfassten Verkehrszeichen; und/oder die Bewertung von
              Maßnahmen zur Straßeninstandhaltung und alle damit zusammenhängenden Aktivitäten, Nachhaltigkeit des
              Straßennetzes.
            </li>
            <li>
              Die in der Web-Anwendung bereitgestellten Verkehrszeichendaten stammen aus verschiedenen Quellen und
              unterliegen unterschiedlichen Datenlizenzen. Aufgrund dieser Lizenzbedingungen können die
              Verkehrszeichendaten nicht generell als Open Data bereitgestellt werden.
            </li>
            <li>
              Nutzer sind verpflichtet, die jeweiligen Lizenzbedingungen der einzelnen Datenquellen zu beachten und
              einzuhalten.
            </li>
          </ol>
        </li>
        <li>
          <b>Nutzung durch andere Organisationen</b>
          <ol>
            <li>
              Andere Organisationen, die die Web-Anwendung nutzen, haben die Möglichkeit, Prozesse an die jeweils
              zuständige Organisation und deren Kontakte weiterzuleiten.
            </li>
            <li>
              Es liegt in der Verantwortung der Nutzer sicherzustellen, dass Weiterleitungen nur an die zuständigen und
              autorisierten Organisationen erfolgen. Die Weitergabe der Daten ist an die vorgegebenen Zwecke gebunden
              (Datenquelle und Datenlizenzen) und nur an vertrauenswürdige Dritte mit einer zweckgemäßen Zuständigkeit
              erlaubt.
            </li>
          </ol>
        </li>
        <li>
          <b>Speicherung und Nutzung personenbezogener Daten</b>
          <ol>
            <li>
              Bei der Nutzung der Web-Anwendung werden Mail-Adresse, Telefonnummer, Profilinformationen und
              Organisationszugehörigkeit der Nutzer gespeichert.
            </li>
            <li>
              Diese Daten werden ausschließlich für die Funktionen der Web-Anwendung genutzt, insbesondere zur
              Verwaltung von Benutzerkonten, zur Authentifizierung und zur Kommunikation zwischen den Nutzern und den
              zuständigen Organisationen.
            </li>
            <li>
              Die Nutzer erklären sich damit einverstanden, dass ihre personenbezogenen Daten im Rahmen der gesetzlichen
              Bestimmungen verarbeitet werden.
            </li>
          </ol>
        </li>
        <li>
          <b>Haftungsausschluss</b>
          <ol>
            <li>
              Das Verkehrsministerium Baden-Württemberg übernimmt keine Gewähr für die Richtigkeit, Vollständigkeit und
              Aktualität der in der Web-Anwendung bereitgestellten Daten.
            </li>
            <li>
              Die Nutzung der Web-Anwendung erfolgt auf eigenes Risiko. Das Verkehrsministerium Baden-Württemberg haftet
              nicht für Schäden, die aus der Nutzung der Web-Anwendung entstehen.
            </li>
          </ol>
        </li>
        <li>
          <b>Datenschutz</b>
          <ol>
            <li>
              Die Verarbeitung der personenbezogenen Daten erfolgt gemäß den geltenden Datenschutzgesetzen. Weitere
              Informationen hierzu finden Sie in unserer <a href="/datenschutz">Datenschutzerklärung</a>.
            </li>
            <li>
              Sie haben das Recht, jederzeit Auskunft über die zu Ihrer Person gespeicherten Daten zu verlangen und ggf.
              deren Berichtigung oder Löschung zu beantragen.
            </li>
          </ol>
        </li>
        <li>
          <b>Änderungen der Nutzungsbedingungen</b>
          <ol>
            <li>
              Das Verkehrsministerium Baden-Württemberg behält sich das Recht vor, diese Nutzungsbedingungen jederzeit
              zu ändern. Änderungen werden auf der Web-Anwendung bekannt gegeben und treten mit ihrer Veröffentlichung
              in Kraft.
            </li>
            <li>
              Durch die fortgesetzte Nutzung der Web-Anwendung nach Bekanntgabe von Änderungen erklären Sie sich mit den
              geänderten Nutzungsbedingungen einverstanden.
            </li>
          </ol>
        </li>
        <li>
          <b>Haftungsausschluss</b>
          <ol>
            <li>
              Das Verkehrsministerium Baden-Württemberg (VM) übernimmt keinerlei Garantien, weder ausdrücklich noch
              impliziert, für die Richtigkeit, Vollständigkeit oder Aktualität der auf dieser Website zur Verfügung
              gestellten Informationen. Dies gilt auch für Inhalte und Angaben von Dritten.
            </li>
            <li>
              Das VM haftet nicht für Schäden, die direkt oder indirekt durch die Nutzung oder Nichtnutzung der
              angebotenen und zur Verfügung gestellten Informationen entstehen. Dies gilt auch für Inhalte und Angaben
              von Dritten. Eine Haftung für Folgeschäden sowie entgangenen Gewinn ist ausgeschlossen.
            </li>
          </ol>
        </li>
        <li>
          <b>Schlussbestimmungen</b>
          <ol>
            <li>
              Sollte eine Bestimmung dieser Nutzungsbedingungen unwirksam sein oder werden, berührt dies die Wirksamkeit
              der übrigen Bestimmungen nicht. Anstelle der unwirksamen Bestimmung gilt eine dem Zweck der Bestimmung
              entsprechende, wirksame Regelung.
            </li>
            <li>
              Es gilt das Recht der Bundesrepublik Deutschland. Gerichtsstand ist, soweit gesetzlich zulässig, der Sitz
              des Verkehrsministeriums Baden-Württemberg.
            </li>
          </ol>
        </li>
      </ol>
      <LegalText>
        Vielen Dank, dass Sie unsere Web-Anwendung nutzen. Wenn Sie Fragen zu diesen Nutzungsbedingungen haben,
        kontaktieren Sie uns bitte unter
        <br />
        <a href="mailto:verkehrszeichenkataster@vm.bwl.de">verkehrszeichenkataster@vm.bwl.de</a>
      </LegalText>
    </ContainerLayout>
  );
}

export const Route = createFileRoute('/_authenticated/nutzungsbedingungen')({
  component: PolicyRoute,
});
